import { Fab, SvgIcon } from '@mui/material';
import React from 'react';

import { palette, spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import useIntercom from '../../../utils/useIntercom';
import useScreenSize from '../../../utils/useScreenSize';

interface ReturnTopButtonProps {
	onClick: () => void;
	isFullScreenMode: boolean;
}

const ReturnTopButton = ({ onClick, isFullScreenMode }: ReturnTopButtonProps) => {
	const { isMdScreen, isLgScreen } = useScreenSize();
	const isDesktopScreen = isLgScreen || isMdScreen;
	const { isIntercomVisible } = useIntercom();

	const offsetOnRight = isIntercomVisible && (isFullScreenMode || !isDesktopScreen);

	const fabSx = {
		position: 'absolute',
		bottom: isFullScreenMode ? spaces.xxxxxl : spaces.md,
		right: offsetOnRight ? spaces.xxxxl : 0,
		background: palette.background.paperElevation2,
	};
	return (
		<Fab onClick={onClick} size="medium" sx={fabSx}>
			<SvgIcon viewBox="0 0 24 24" component={getMuiIcon('arrowUpLong')} />
		</Fab>
	);
};

export default ReturnTopButton;
